import i18next from 'i18next';
import React from 'react';
import { ROUTE_DUPLI_RESTITUITI, ROUTE_RICEVUTE, ROUTE_TRASMISSIONE } from './frontendRouting';


export const paragrafi = {
    trasmissionePegnoNonPossessorio:{
        titolo : "Trasmissione domanda",
        testo  : <><p>In questa sezione è possibile:</p>
        <ul>
          <li>Inviare una domanda di iscrizione, rinnovazione, modifica o cancellazione di pegni non possessori firmata digitalmente.</li>
        </ul>
        <p>Il pegno non possessorio si costituisce per contratto e ha effetto verso i terzi esclusivamente con l’iscrizione in un registro informatizzato costituito presso l’Agenzia delle entrate e denominato “Registro dei pegni mobiliari non possessori”.<br></br>
         L’art. 1, co. 4, d.l. n. 59/2016 prevede che “dal momento dell’iscrizione il pegno prende grado ed è opponibile ai terzi e nelle procedure esecutive e concorsuali”.<br></br> 
         L’iscrizione ha una durata di dieci anni, rinnovabile per mezzo di una nuova iscrizione nel registro prima della scadenza del decimo anno. <br></br>
         La cancellazione dell’iscrizione può essere chiesta su consenso del creditore o ordinata giudizialmente. <br></br>
         L’accesso al registro avviene con modalità esclusivamente informatiche.
          <br></br>
          <br></br>
          <b>Riferimenti normativi:</b>
          <ul>
          <li> Decreto-legge 3 maggio 2016, n. 59, convertito, con modificazioni, dalla legge 30 giugno 2016, n. 119;</li>
          <li> Regolamento sul Registro dei pegni mobiliari non possessori, adottato con decreto ministeriale 25 maggio 2021, n. 114.</li>
          </ul>
        </p>
        </>,
        tipoHome: "MP"
       },
    ricevutePegnoNonPossessorio:{
      titolo : "Ricevute domanda",
      testo  : <><p>In questa sezione è possibile:</p>
        <ul>
          <li>Visualizzare gli esisti dell'elaborazione delle domande di pegno inviate.</li>
          <li>Effettuare il download delle ricevute di trasmissione e pagamento</li>
          <li>Effettuare il download del "Certificato di eseguita formalità"</li>
        </ul>
        </>,
      tipoHome: "MP"


    },
    compilazionePegnoNonPossessorio:{
      titolo : "Compilazione domanda",
      testo  :<>
      <p>In questa sezione è possibile:</p>
<ul>
<li>Compilare una nuova domanda (di iscrizione, rinnovazione, modifica o cancellazione di pegni non possessori).</li>
<li>Visualizzare le domande attualmente in lavorazione.</li>
</ul>
    <div className='row'>
      <div className='col'>
      <a href={process.env.LINK_COMPILAZIONE} title="Compilazione" class="btn btn-primary mr-2"><span class="chip-label text-truncate">Compilazione</span></a>


        {/* <AppButton isLinkStyle={true} titleKey="Compilazione" customClass="external-link"  onClick={this.onClickCompilazione} /> */}
        
      </div>
    </div>
        </>,
      tipoHome: "MP"

    },
    trasmissioneMUI:{
      titolo : "Trasmissione Modello Unico",
      testo  : <>
      <p> Tramite questa funzionalità i soggetti abilitati possono inviare telematicamente il documento Modello Unico Informatico.  <br></br></p>
       {/* <a href={ROUTE_TRASMISSIONE.slice(1)} title="Vai all'applicazione" class="btn btn-primary mr-2"><span class="chip-label text-truncate">Effettua una trasmissione</span></a>
       */}</>,
      tipoHome: "UN"
     },
     ricevuteMUI:{
      titolo : "Ricevute Modello Unico",
      testo  :  <><p>In questa sezione è possibile:</p>
      <ul>
      <li>Visualizzare gli esisti dell'elaborazione dei documenti inviati tramite la funzionalità di trasmissione.</li>
      <li>Effettuare il download delle ricevute di trasmissione </li>
      <li>Effettuare il download del duplo per le pratiche inviate</li>
      </ul>
      {/* <a href={ROUTE_RICEVUTE.slice(1)} title="Vai all'applicazione" class="btn btn-primary mr-2"><span class="chip-label text-truncate">Visualizza le ricevute</span></a>
 */}
      </>,
      tipoHome: "UN"
     },
     compilazioneMUI:{
      titolo : "Compilazione Modello Unico",
      testo  :  <><p>Questa funzionalità permette la compilazione del Modello unico informatico per l'esecuzione degli adempimenti di registrazione, trascrizione, iscrizione, annotazione e voltura. E' possibile scegliere la versione adeguata alle proprie esigenze tra le seguenti:</p>
      <ul>
        <li>Completa</li>
        <li>Completa per trasmissione destinata ai soli uffici del Territorio</li>
        <li>Semplificata</li>
        <li>Semplificata per ufficio</li>
      </ul>
      <br></br>
      <p>
       La versione completa, dedicata ai notai e agli altri pubblici ufficiali autorizzati, consente l'esecuzione per via telematica degli adempimenti di registrazione, trascrizione/iscrizione/annotazione e voltura</p>
      <br></br>
      La versione "Completa per trasmissione destinata ai soli uffici del Territorio" consente l'esecuzione degli adempimenti di trascrizione/iscrizione/annotazione e voltura; non consente l'esecuzione dell'adempimento di registrazione e voltura tavolare. 
      <br></br>
      Le versioni "Semplificata"  e "Semplificata per ufficio" consentono di predisporre le formalità di trascrizione/iscrizione/annotazione e la voltura da nota di trascrizione; tali versioni sono dedicate agli utenti dello sportello accettazione dei Reparti Servizi di Pubblicità immobiliare.

      <br></br>
      <a href={process.env.LINK_COMPILAZIONE_MUI} title="Compilazione" class="btn btn-primary mr-2"><span class="chip-label text-truncate">Effettua una compilazione</span></a>
      </>,
      tipoHome: "UN"
     },
     assistenzaMUI:{
      titolo : "Assistenza",
      testo  :  <>
      <a href={process.env.SPECIFICHE_TECNICHE} target="_blank" className='external-link'>Specifiche tecniche</a>
        <br/>
        <a href={process.env.MANUALE_UTENTE_MUI} target="_blank" className='external-link'>Manuale utente</a>

         </>,
      tipoHome: "UN"
     },
     restituzioneDuplo:{
      titolo : "Richiesta di restituzione del duplo",
      testo  :  <><p>Questa funzionalità permette di richiedere la restituzione del duplo in vita telematica.</p>
      
      <p>L’utilizzo di questa funzionalità, “Richiesta di restituzione del duplo”, è consentito a tutti i soggetti che non sono attualmente abilitati su Sister al servizio di presentazione telematico del documento Modello Unico, pertanto i notai e gli altri P.U. dovranno continuare ad utilizzare la piattaforma Sister per l’invio del MU e visualizzazione del duplo restituito.  </p>
      
      <p>Il duplo restituito non potrà esser richiesto più volte né dal medesimo soggetto né da soggetti differenti rispetto a chi lo ha richiesto la prima volta</p>
      
      {/* <a href={ROUTE_DUPLI_RESTITUITI.slice(1)} title="Vai all'applicazione" class="btn btn-primary mr-2"><span class="chip-label text-truncate">Esegui una richiesta</span></a>
       */}
      </>,
      tipoHome: "UN"
     },
     assistenzaPegno:{
      titolo : "Assistenza",
      testo  :  <>
        <a href={process.env.REGOLAMENTO_PNP} target="_blank" className='external-link'>Pegno non possessorio - Cos'è?</a>
        <br/>
        <a href={process.env.MANUALE_UTENTE_PNP} target="_blank" className='external-link'>Manuale utente</a>
      </>,
      tipoHome: "MP"
     },
trasmissionePegnoNonPossessorioCertificati:{
      titolo : "Trasmissione certificato di pegno",
      testo  : <><p>In questa sezione è possibile:</p>
      <ul>
        <li>Inviare una richiesta di certificato o rilascio di copia del pegno non possessorio firmata digitalmente.</li>
      </ul>
      <p>Il pegno non possessorio si costituisce per contratto e ha effetto verso i terzi esclusivamente con l’iscrizione in un registro informatizzato costituito presso l’Agenzia delle entrate e denominato “Registro dei pegni mobiliari non possessori”.<br></br>
       L’art. 1, co. 4, d.l. n. 59/2016 prevede che “dal momento dell’iscrizione il pegno prende grado ed è opponibile ai terzi e nelle procedure esecutive e concorsuali”.<br></br> 
       L’iscrizione ha una durata di dieci anni, rinnovabile per mezzo di una nuova iscrizione nel registro prima della scadenza del decimo anno. <br></br>
       La cancellazione dell’iscrizione può essere chiesta su consenso del creditore o ordinata giudizialmente. <br></br>
       L’accesso al registro avviene con modalità esclusivamente informatiche.
        <br></br>
        <br></br>
        <b>Riferimenti normativi:</b>
        <ul>
        <li> Decreto-legge 3 maggio 2016, n. 59, convertito, con modificazioni, dalla legge 30 giugno 2016, n. 119;</li>
        <li> Regolamento sul Registro dei pegni mobiliari non possessori, adottato con decreto ministeriale 25 maggio 2021, n. 114.</li>
        </ul>
      </p>
      </>,
      tipoHome: "CP"
     },
  ricevutePegnoNonPossessorio:{
    titolo : "Ricevute domanda",
    testo  : <><p>In questa sezione è possibile:</p>
      <ul>
        <li>Visualizzare gli esisti dell'elaborazione delle domande di pegno inviate.</li>
        <li>Effettuare il download delle ricevute di trasmissione e pagamento</li>
        <li>Effettuare il download del "Certificato di eseguita formalità"</li>
      </ul>
      </>,
    tipoHome: "CP"


  }
     

       
  
  
  }
    

